import { RowOption } from 'uplisting-frontend/pods/xcalendar/controller';

export const RESTRICTION_ROWS: RowOption[] = [
  RowOption.mlos,
  RowOption.closedForArrivals,
  RowOption.closedForDepartures,
];

export const RATE_ROWS: RowOption[] = [
  RowOption.rates,
  RowOption.airbnbRates,
  RowOption.directRates,
  RowOption.bookingDotComRates,
  RowOption.googleRates,
  RowOption.homeAwayRates,
];

const LANE_LABELS = new Set<string>([
  RowOption.mlos,
  RowOption.rates,
  RowOption.homeAwayRates,
]);

export function rowLabelKey(
  field: RowOption,
  part: 'title' | 'tooltip',
): string {
  const scope = LANE_LABELS.has(field) ? 'lane' : 'aside';

  return `calendar.rows.${scope}.${field}.${part}`;
}
